
// Simple product description toggle; default export for theme.js
export default class Product {
  constructor() {
    this.content = document.getElementById('ProductDescriptionContent');
    this.toggle = document.getElementById('ProductDescriptionToggle');
    if (!this.content || !this.toggle) return;
    this.expanded = false;
    this.toggle.addEventListener('click', this.handleToggle.bind(this));
  }

  handleToggle() {
    this.expanded = !this.expanded;
    if (this.expanded) {
      this.content.style.maxHeight = this.content.scrollHeight + 'px';
      this.toggle.textContent = 'Show Less';
    } else {
      this.content.style.maxHeight = window.innerHeight + 'px';
      this.toggle.textContent = 'Show More';
    }
  }
}

  
  

